import {
  FileOutlined,
  LoadingOutlined,
  MinusSquareOutlined,
  PaperClipOutlined,
  PlusSquareOutlined,
  SignatureFilled,
} from '@ant-design/icons';
import { DocumentoDTO } from '@framework/api-client';
import { FlexRow, ISODate } from '@framework/ui';
import { Button, Space, Tooltip } from 'antd';
import { useState } from 'react';
import { useDocumentalDocumentQuery } from '../useDocumentalDocumentQuery';
import { DocumentalAttachmentDownloadButton } from './DocumentalAttachmentDownloadButton';
import { DocumentalDownloadButton } from './DocumentalDownloadButton';
import { DocumentalIcon } from './DocumentalIcon';
import { DocumentalRow } from './DocumentalRow';

/**
 * Visualizzazione di un documento e dei suoi allegati
 */
export interface IDocumentalDocumentRowProps {
  dossierId: string | null | undefined;
  documentToken: string | null | undefined;
  document: DocumentoDTO;
}

export function DocumentalDocumentRow(props: IDocumentalDocumentRowProps) {
  const { documentToken, document, dossierId } = props;
  const [open, setOpen] = useState(false);

  const { attachments, isLoading, error } = useDocumentalDocumentQuery(
    dossierId,
    document.idFileDocumento,
    {
      documentalToken: documentToken ?? '',
      enabled: open,
    },
  );

  return (
    <>
      <DocumentalRow key={document.idFileDocumento}>
        <FlexRow
          right={
            <Space size={0}>
              <Button
                type="link"
                onClick={() => setOpen(!open)}
                aria-label={open ? 'Nascondi allegati' : 'Mostra allegati'}
              >
                {/* <PaperClipOutlined aria-hidden /> */}
                {open ? <MinusSquareOutlined /> : <PlusSquareOutlined />}
                {/* {open ? 'Nascondi allegati' : 'Mostra allegati'} */}
                Allegati
                {/* <DownOutlined rotate={open ? 0 : -90} /> */}
              </Button>
              <DocumentalDownloadButton
                token={documentToken}
                dossierId={dossierId}
                documentId={document.idFileDocumento}
                filename={document.nomeFile}
              />
            </Space>
          }
        >
          <Space>
            <DocumentalIcon style={{ paddingLeft: 2 }}>
              <FileOutlined aria-hidden />
            </DocumentalIcon>
            <span>{document.nomeFile}</span>
            {document.flFirmato && (
              <Tooltip title="Documento firmato">
                <SignatureFilled aria-hidden />
              </Tooltip>
            )}
            <em>
              <ISODate date={document.dataModifica} />
            </em>
          </Space>
        </FlexRow>
      </DocumentalRow>
      {open && (
        <div style={{ marginLeft: '16px' }}>
          {isLoading && (
            <Space style={{ padding: '4px' }}>
              <LoadingOutlined /> Caricamento allegati...
            </Space>
          )}
          {error && <div>Errore durante il caricamento degli allegati</div>}
          {attachments && (
            <div>
              {attachments.map(attachment => (
                <DocumentalRow key={attachment.id}>
                  <FlexRow
                    right={
                      <DocumentalAttachmentDownloadButton
                        token={documentToken}
                        dossierId={dossierId}
                        documentId={document.idFileDocumento}
                        attachmentId={attachment.id}
                        filename={
                          attachment.name ?? 'Allegato_${attachment.id}'
                        }
                      />
                    }
                  >
                    <Space>
                      <DocumentalIcon>
                        <PaperClipOutlined aria-hidden />
                      </DocumentalIcon>
                      <span>{attachment.description}</span>
                      <em>{attachment.name}</em>
                    </Space>
                  </FlexRow>
                </DocumentalRow>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
}
